import { CityCreate } from './CityCreate';
import { CityEdit } from './CityEdit';
import { CityList } from './CityList';
import { CityShow } from './CityShow';

export const edit = CityEdit;
export const list = CityList;
export const create = CityCreate;
export const show = CityShow;
